import { render, staticRenderFns } from "./AddonsTypeForm.vue?vue&type=template&id=028e00ec&scoped=true&"
import script from "./AddonsTypeForm.vue?vue&type=script&lang=js&"
export * from "./AddonsTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./AddonsTypeForm.vue?vue&type=style&index=0&id=028e00ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028e00ec",
  null
  
)

export default component.exports